import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BodyText } from '@paypalcorp/pp-react-text';
import { isExternalFlow } from '../utility/externalIntegrationUtils';

export class ConfirmationReturnText extends Component {
  render() {
    if (isExternalFlow()) {
      return null;
    }

    return (
      <div className="confirmation_reciept_wrapper">
        <BodyText className="text-center">{this.props.returnText}</BodyText>
      </div>
    );
  }
}

export default ConfirmationReturnText;

ConfirmationReturnText.propTypes = {
  returnText: PropTypes.string,
};
